export const knownHeaderOverlays = ['div.navbar.fixed', 'div.navbar-layout-default', 'div.page-header', 'div.navbar']
